import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { Mother, PlacaVideo } from '../model';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_MotherVideo extends FuncionCompatilibidadBase<Mother, PlacaVideo> {
  funciones = {
    tipo: (mother: Mother, video: PlacaVideo): Incompatibilities | null => {
      let tipoVideo = video.$caracteristicas.tipo;
      return !mother.$caracteristicas[tipoVideo == 'pcie' ? 'nro_pcie' : tipoVideo] ?
          {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: `La mother seleccionada no soporta el tipo de placa ${tipoVideo}`,
          }
        : null;
    },
  };
}
